import type { DurableWriteFn } from "@jackedlogs/ui";

import { apiFetch } from "./api";

// THE web half of the durable-write seam (`@jackedlogs/ui` seams.ts).
//
// Web has no offline queue, and the seam's own doc comment forbids faking
// one: this NEVER answers `queued`, only `sent` or `rejected`. `apiFetch`
// stamps its own Idempotency-Key per call since web never retries a write
// behind the caller's back.
export const durableWrite: DurableWriteFn = async (op) => {
  try {
    await apiFetch(op.path, {
      method: op.method,
      ...(op.body === undefined ? {} : { body: op.body }),
    });
    return { outcome: "sent" };
  } catch (error) {
    return { outcome: "rejected", error };
  }
};
